/**
 * A/B test framework — QA force-variant URL parser.
 *
 * Parses ?ab_force=<variant> from the current URL on app boot and persists the value
 * to sessionStorage under key 'mm_ab_force'. The axios interceptor reads that key and
 * sends X-Force-Variant on customer-facing API calls, letting QA / admins pin a variant
 * without restarting the assignment loop.
 *
 * Special value 'clear' removes the override.
 *
 * Note: the backend still requires admin authentication before honoring X-Force-Variant.
 * This utility just plumbs the header through; it grants no privilege on its own.
 *
 * A/B 测试框架 — QA 用的强制变体 URL 解析器。
 * 应用启动时读取 ?ab_force=<variant>，写入 sessionStorage（key: mm_ab_force）。
 * 后端仍会校验管理员鉴权，前端只是把 header 透传。
 */
export function initAbForceFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search)
    const force = params.get('ab_force')
    if (force === 'clear') {
      sessionStorage.removeItem('mm_ab_force')
    } else if (force) {
      sessionStorage.setItem('mm_ab_force', force)
    }
  } catch (e) {
    // sessionStorage may be blocked in some embedded webviews — silently ignore.
    // 部分嵌入式 webview 可能禁用 sessionStorage，静默忽略即可。
  }
}
